<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    @if (menuItemsStakeholders.includes(currentContent)) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Stakeholders <app-breadcrumb [menuItems]="menuItems" [currentContent]="currentContent"></app-breadcrumb>
        </h4>
        <div class="card-body">
          <h5 class="filters">Filters</h5>
          <form class="bg-light border rounded-lg px-3 pt-2 pb-1 filters" (ngSubmit)="search()">
            <label>Category</label>
            <div class="row">
              <div class="form-group col-md-12 mb-0">
                <div class="btn-group-toggle" data-bs-toggle="buttons">
                  <label class="btn btn-outline-primary me-1 mt-1 mt-sm-0" [ngClass]="{ 'active': category.includes('institutions') }">
                    <input type="checkbox" name="checkCategory1" (change)="checkCategory('institutions')" [checked]="category.includes('institutions')">
                    Institutions <i class="fa" [ngClass]="{ 'fa-square-o': !category.includes('institutions'), 'fa-check-square-o': category.includes('institutions') }"></i>
                  </label>
                  <label class="btn btn-outline-primary me-1 mt-1 mt-sm-0" [ngClass]="{ 'active': category.includes('media') }">
                    <input type="checkbox" name="checkCategory2" (change)="checkCategory('media')" [checked]="category.includes('media')">
                    Media <i class="fa" [ngClass]="{ 'fa-square-o': !category.includes('media'), 'fa-check-square-o': category.includes('media') }"></i>
                  </label>
                  <label class="btn btn-outline-primary me-1 mt-1 mt-sm-0" [ngClass]="{ 'active': category.includes('corporate') }">
                    <input type="checkbox" name="checkCategory3" (change)="checkCategory('corporate')" [checked]="category.includes('corporate')">
                    Third parties <i class="fa" [ngClass]="{ 'fa-square-o': !category.includes('corporate'), 'fa-check-square-o': category.includes('corporate') }"></i>
                  </label>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="form-group col-md-3">
                <label>Last name</label>
                <input type="text" class="form-control" [ngClass]="{ 'is-touched': lastName }"
                  name="lastName" [(ngModel)]="lastName" (change)="search()" placeholder="Last name">
              </div>
              <div class="form-group col-md-3">
                <label>Role</label>
                <select class="form-control" [ngClass]="{ 'is-touched': job }" name="job" [(ngModel)]="job" (change)="search()">
                  <option value="" selected>Any role</option>
                  <optgroup label="Institutions">
                    @for (role of roles; track role) {
                      <option [value]="role">{{role}}</option>
                    }
                  </optgroup>
                  <optgroup label="Media">
                    @for (role of rolesMedia; track role) {
                      <option [value]="role">{{role}}</option>
                    }
                  </optgroup>
                  <optgroup label="Other">
                    @for (role of rolesOther; track role) {
                      <option [value]="role">{{role}}</option>
                    }
                  </optgroup>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Government</label>
                <select class="form-control" [ngClass]="{ 'is-touched': _governments }" name="_governments" [(ngModel)]="_governments" (change)="search()">
                  <option value="" selected>Any government</option>
                  @for (government of governments; track government) {
                    <option [value]="government._id">{{government.name}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Organ</label>
                <select class="form-control" [ngClass]="{ 'is-touched': organ }" name="organ" [(ngModel)]="organ" (change)="search()">
                  <option value="" selected>Any organ</option>
                  @for (organ of organs; track organ) {
                    <option [value]="organ">{{organ}}</option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label>Legislature</label>
                <select class="form-control" [ngClass]="{ 'is-touched': _legislatures }" name="_legislatures" [(ngModel)]="_legislatures" (change)="search()">
                  <option value="" selected>Any legislature</option>
                  @for (legislature of legislatures; track legislature) {
                    <option [value]="legislature._id">{{legislature.roman}}</option>
                  }
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Ministry</label>
                <select class="form-control" [ngClass]="{ 'is-touched': office }" name="office" [(ngModel)]="office" (change)="search()">
                  <option value="" selected>Any ministry</option>
                  <optgroup label="Ministry">
                    @for (office of offices; track office) {
                      <option [value]="office">{{office}}</option>
                    }
                  </optgroup>
                  <optgroup label="Ministry no portfolio">
                    @for (office of officesNoPortfolio; track office) {
                      <option [value]="office">{{office}}</option>
                    }
                  </optgroup>
                  <optgroup label="Other">
                    @for (office of officesOther; track office) {
                      <option [value]="office">{{office}}</option>
                    }
                  </optgroup>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Commission</label>
                <select class="form-control" [ngClass]="{ 'is-touched': _commissions }" name="_commissions" [(ngModel)]="_commissions" (change)="search()">
                  <option value="" selected>Any commission</option>
                  <optgroup label="Camera">
                    @for (commission of commissionsCamera; track commission) {
                      <option [value]="commission._id">
                        {{commission.name}} ({{commission.roman}})
                      </option>
                    }
                  </optgroup>
                  <optgroup label="Senato">
                    @for (commission of commissionsSenato; track commission) {
                      <option [value]="commission._id">
                        {{commission.name}} ({{commission.roman}})
                      </option>
                    }
                  </optgroup>
                  <optgroup label="European Parliament">
                    @for (commission of commissionsEU; track commission) {
                      <option [value]="commission._id">
                        {{commission.name}} ({{commission.roman}})
                      </option>
                    }
                  </optgroup>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Commission role</label>
                <select class="form-control" [ngClass]="{ 'is-touched': jobCommissions }" name="jobCommissions" [(ngModel)]="jobCommissions" (change)="search()">
                  <option value="" selected>Any commission role</option>
                  <option value="President">President</option>
                  <option value="Vicepresident">Vicepresident</option>
                  <option value="Secretary">Secretary</option>
                  <option value="Member">Member</option>
                </select>
              </div>
            </div>
            <div class="row">
              <!-- <div class="form-group col-md-3">
              <label>Party leader</label>
              <select class="form-control" [ngClass]="{ 'is-touched': partyLeader }" name="partyLeader" [(ngModel)]="partyLeader" (change)="search()">
                <option value="" selected>Anyone</option>
                <option value="1">Yes</option>
              </select>
            </div> -->
            <div class="form-group col-md-3">
              <label>Party</label>
              <select class="form-control" [ngClass]="{ 'is-touched': _party }" name="_party" [(ngModel)]="_party" (change)="search()">
                <option value="" selected>Any party</option>
                <optgroup label="Italy">
                  @for (party of parties; track party) {
                    <option [value]="party._id">{{party.name}}</option>
                  }
                </optgroup>
                <optgroup label="EU">
                  @for (party of partiesEU; track party) {
                    <option [value]="party._id">{{party.name}}</option>
                  }
                </optgroup>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label>Electoral district</label>
              <select class="form-control" [ngClass]="{ 'is-touched': college }" name="college" [(ngModel)]="college" (change)="search()">
                <option value="" selected>Any electoral district</option>
                @for (college of collegeRegions; track college) {
                  <option [value]="college">{{college}}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-3" [ngClass]="{ 'disabled': !category.includes('media') }">
              <label>Media company</label>
              <select class="form-control" [ngClass]="{ 'is-touched': _media }" name="_media" [(ngModel)]="_media" (change)="search()">
                <option value="" selected>Any media company</option>
                @for (media of medias; track media) {
                  <option [value]="media._id">{{media.name}}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-3">
              <label>MEP Country</label>
              <select class="form-control" [ngClass]="{ 'is-touched': country }" name="country" [(ngModel)]="country" (change)="search()">
                <option value="" selected>Any country</option>
                @for (country of euCountries; track country) {
                  <option [value]="country">{{country}}</option>
                }
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Notes</label>
              <input type="text" class="form-control" [ngClass]="{ 'is-touched': notes }"
                name="notes" [(ngModel)]="notes" (change)="search()" placeholder="eg: Notes">
            </div>
            <div class="form-group col-md-3">
              <label>Topic</label>
              <select class="form-control" [ngClass]="{ 'is-touched': topics }" name="topics" [(ngModel)]="topics" (change)="search()">
                <option value="" selected>Any topic</option>
                @for (cluster of clusters; track cluster) {
                  <option [value]="cluster">{{cluster}}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-3">
              <label>English speaker</label>
              <select class="form-control" [ngClass]="{ 'is-touched': english }" name="english" [(ngModel)]="english" (change)="search()">
                <option value="" selected>Any speaker</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
        </form>
        <hr class="mb-2">
        <div class="row">
          <div class="col-md-6">
            @if (isLoading.stakeholders) {
              <p>
                <app-spinner [condition]="isLoading.stakeholders"></app-spinner>
              </p>
            }
            @if (!isLoading.stakeholders && politicians?.length === 0) {
              <p>
                Nothing found.
              </p>
            }
            @if (isSearching && !isLoading.stakeholders && politicians?.length) {
              <p>
                <span class="badge badge-primary">{{count}}</span> results found:
              </p>
            }
          </div>
          <div class="col-md-6 text-end">
            @if (canExportCsv) {
              <button class="btn btn-primary btn-sm hide-print" (click)="search(0, true)"
                data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Export takes account of the current filters">
                <i class="fa fa-download"></i> Export (CSV)
              </button>
            }
          </div>
        </div>
        <div class="row row-cols-1 row-cols-lg-2" [ngClass]="{ 'disabled': isLoading.stakeholders }">
          @for (politician of politicians; track politician._id) {
            <div class="col mb-3">
              <app-stakeholder [politician]="politician"></app-stakeholder>
            </div>
          }
        </div>
        @if (politicians?.length) {
          <div>
            <app-pagination [isLoading]="isLoading.stakeholders" [count]="count" [perPage]="perPage" [page]="page" eventName="getStakeholders"></app-pagination>
            <app-spinner [condition]="isLoading.stakeholders"></app-spinner>
          </div>
        }
      </div>
    </div>
  }
  @if (currentContent === 'add-new-stakeholder' && !politicianAdded) {
    <div class="card border-0">
      <h4 class="card-header border-0">
        Stakeholders &raquo; Add new stakeholder
      </h4>
      <div class="card-body">
        <app-add-stakeholder-form [governments]="governments"
          [legislatures]="legislatures"
          [commissionsCamera]="commissionsCamera"
          [commissionsSenato]="commissionsSenato"
          [commissionsEU]="commissionsEU"
          [parties]="parties"
          [partiesEU]="partiesEU"
        [medias]="medias"></app-add-stakeholder-form>
      </div>
    </div>
  }
  @if (currentContent === 'add-new-stakeholder' && politicianAdded) {
    <div class="card border-0">
      <h4 class="card-header border-0">
        Stakeholders &raquo; Add new stakeholder
      </h4>
      <div class="card-body">
        <p>
          Stakeholder added successfully!
        </p>
        <a class="nav-link" [routerLink]="" (click)="currentContent = 'stakeholders'; politicianAdded = false">
          <i class="fa fa-globe"></i> Go to stakeholders page
        </a>
        <a class="nav-link" [routerLink]="" (click)="politicianAdded = false">
          <i class="fa fa-user-plus"></i> Add another stakeholder
        </a>
      </div>
    </div>
  }
  @if (currentContent === 'add-new-media' && !mediaAdded) {
    <div class="card border-0">
      <h4 class="card-header border-0">
        Stakeholders &raquo; Add new Media Company (for Media stakeholders)
      </h4>
      <div class="card-body">
        <app-add-media-form></app-add-media-form>
        <hr>
          <h5 class="pt-1">Media companies</h5>
          <div class="form-group col-md-6 px-0 pt-1">
            <input type="text" class="form-control mb-2" placeholder="Filter by name" [(ngModel)]="mediaCompanyFilter">
          </div>
          <div class="col-md-8 px-0 pt-1">
            <table class="table table-bordered table-sm">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                </tr>
              </thead>
              <tbody>
                @for (media of medias | filter:'name':mediaCompanyFilter; track media) {
                  <tr>
                    <td>{{media.name}}</td>
                    <td>{{media.email}}</td>
                    <td>{{media.phone}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
    @if (currentContent === 'add-new-media' && mediaAdded) {
      <div class="card border-0">
        <h4 class="card-header border-0">
          Stakeholders &raquo; Add new Media Company (for Media stakeholders)
        </h4>
        <div class="card-body">
          <p>
            Item added successfully!
          </p>
          <a class="nav-link" [routerLink]="" (click)="currentContent= 'add-new-stakeholder'; mediaAdded = false">
            <i class="fa fa-user-plus"></i> Add new stakeholder
          </a>
          <a class="nav-link" [routerLink]="" (click)="mediaAdded = false">
            <i class="fa fa-plus-circle"></i> Add another item
          </a>
        </div>
      </div>
    }

  </div>

</div>

